export const UUID_REGEX = /[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-5][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}/;

/**
 * Extracts the first UUID found in the given value.
 * Returns the lowercase UUID string, or null if none found.
 */
export const extractUuid = (value?: string | null): string | null => {
  if (!value) {
    return null;
  }
  const match = String(value).match(UUID_REGEX);
  return match ? match[0].toLowerCase() : null;
};
